// extracted by mini-css-extract-plugin
export default {"blockLayer":"style_blockLayer__9Wju4","content":"style_content__dbf3Y"};